// import { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import MainLoader from "../../components/loading/MainLoader";
// import CustomBreadcrumb from "../../components/customBreadcrumb/CustomBreadcrumb";
// import Title from "../../components/title/Title";
// import { DataGrid, GridColDef } from "@mui/x-data-grid";
// import Paper from "@mui/material/Paper";
// import Fab from "@mui/material/Fab";
// import AddIcon from "@mui/icons-material/Add";
// import Modal from "@mui/material/Modal";
// import Box from "@mui/material/Box";
// import MessageForm from "./message_compose";
// import { useNavigate } from "react-router-dom";
// import { FiEye } from "react-icons/fi";
// import Button from "@mui/material/Button";
// import { BASE_URL } from "../../const/URL";

// const statusColors: { [key: string]: string } = {
//   REQUESTED: "#4caf50",
//   ACKNOWLEDGED: "#ff9800",
//   COMPLETED: "#2196f3",
// };

// const columns: GridColDef[] = [
//   { field: "id", headerName: "Ref No", width: 100 },
//   { field: "subject", headerName: "Subject", width: 280 },
//   { field: "circuit", headerName: "Service ID", width: 100 },
//   { field: "createdAt", headerName: "Date & Time", width: 200 },
//   { field: "origin", headerName: "Originator", width: 200 },
//   {
//     field: "status",
//     headerName: "Status",
//     width: 170,
//     renderCell: (params) => (
//       <span
//         style={{
//           padding: "5px 10px",
//           borderRadius: "15px",
//           color: "#fff",
//           backgroundColor: statusColors[params.value] || "#607d8b",
//           fontWeight: "bold",
//           textTransform: "capitalize",
//         }}
//       >
//         {params.value}
//       </span>
//     ),
//   },
//   {
//     field: "actions",
//     headerName: "Actions",
//     width: 100,
//     renderCell: (params) => {
//       // eslint-disable-next-line react-hooks/rules-of-hooks
//       const navigate = useNavigate();
//       return (
//         <Button
//           onClick={() =>
//             navigate(`/messages/inbox/${params.row.id}`, {
//               state: { subject: params.row.subject, status: params.row.status },
//             })
//           }
//           startIcon={
//             <FiEye
//               style={{
//                 color: "#143D60",
//                 alignContent: "center",
//                 alignItems: "center",
//               }}
//             />
//           }
//           style={{
//             padding: "10px",
//             color: "white",
//             alignContent: "center",
//             alignItems: "center",
//             border: "none",
//             borderRadius: "20px",
//             cursor: "pointer",
//             fontWeight: "bold",
//           }}
//         ></Button>
//       );
//     },
//   },
// ];

// const Messages = () => {
//   const [loading, setLoading] = useState<boolean>(false);
//   const [rows, setRows] = useState<any[]>([]);
//   const [openModal, setOpenModal] = useState<boolean>(false);

//   const paginationModel = { page: 0, pageSize: 10 };

//   const fetchMessages = useCallback(async () => {
//     setLoading(true);
//     try {
//       const token = localStorage.getItem("enterprise_portal_access_Token");
//       const response = await axios.get(
//         `${BASE_URL}/api/v1/conversations/company`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.data.isSuccess) {
//         const formattedRows = response.data.dataBundle.map((item: any) => ({
//           id: item.id,
//           subject: item.subject,
//           circuit: item.circuit,
//           createdAt: new Date(item.createdAt).toLocaleString(),
//           origin: item.origin,
//           status: item.status,
//           unReadMsgCount: item.unReadMsgCount || 0,
//         }));
//         setRows(formattedRows);
//       }
//     } catch (error) {
//       console.error("Error fetching messages:", error);
//     }
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     fetchMessages();
//   }, [fetchMessages]);

//   const handleOpenModal = () => setOpenModal(true);
//   const handleCloseModal = () => {
//     setOpenModal(false);
//     fetchMessages();
//   };

//   return (
//     <div className="page-container">
//       <MainLoader show={loading} />

//       <CustomBreadcrumb
//         items={[
//           { path: "/", title: "Home" },
//           { path: "/messages/inbox", title: "Messages" },
//         ]}
//       />
//       <Title>Messages</Title>

//       <Paper
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           flex: 1,
//           height: "100%",
//           minHeight: 300,
//           marginTop: "20px",
//           borderRadius: "20px",
//           overflow: "hidden",
//           boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
//           p: 1,
//           mx: "auto",
//           width: "100%",
//           "& .MuiTablePagination-root": {
//             display: "flex",
//             alignItems: "baseline",
//             justifyContent: "flex-end",
//             minHeight: "56px",
//             gap: "8px",
//           },
//           "& .MuiTablePagination-spacer": {
//             order: 2,
//           },
//           "& .MuiTablePagination-selectLabel": {
//             order: 0,
//             display: "flex",
//             alignItems: "baseline",
//             padding: "15px",
//             height: "36px",
//           },
//           "& .MuiTablePagination-select": {
//             order: 1,
//             display: "flex",
//             alignItems: "center",
//             height: "36px",
//           },
//           "& .MuiTablePagination-displayedRows": {
//             order: 3,
//             display: "flex",
//             padding: "15px",
//             alignItems: "baseline",
//             height: "36px",
//           },
//           "& .MuiTablePagination-actions": {
//             order: 4,
//             display: "flex",
//             alignItems: "center",
//             marginRight: "80px",
//           },
//         }}
//       >
//         <DataGrid
//           rows={rows}
//           columns={columns}
//           initialState={{ pagination: { paginationModel } }}
//           pageSizeOptions={[5, 10, 15]}
//           getRowClassName={(params) =>
//             params.row.unReadMsgCount > 0 ? "unread-row" : ""
//           }
//           sx={{
//             border: 0,
//             "& .MuiDataGrid-columnHeaders": {
//               backgroundColor: "#E4EFE7",
//               color: "GrayText",
//               fontSize: "1rem",
//               fontWeight: "bold",
//             },
//             "& .MuiDataGrid-cell": {
//               fontSize: "0.9rem",
//               fontWeight: "500",
//             },
//             "& .MuiDataGrid-row": {
//               "&.unread-row": {
//                 backgroundColor: "#fff3e0",
//                 "& .MuiDataGrid-cell": {
//                   fontWeight: "bold !important",
//                 },
//               },
//             },
//           }}
//           autoHeight
//         />
//       </Paper>

//       <Fab
//         color="primary"
//         aria-label="add"
//         sx={{
//           position: "fixed",
//           bottom: 16,
//           right: 66,
//         }}
//         onClick={handleOpenModal}
//       >
//         <AddIcon />
//       </Fab>

//       <Modal open={openModal} onClose={handleCloseModal}>
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: { xs: "90%", sm: "80%", md: "60%", lg: "50%" },
//             bgcolor: "background.paper",
//             boxShadow: 24,
//             p: 4,
//             borderRadius: 2,
//           }}
//         >
//           <MessageForm onClose={handleCloseModal} />
//         </Box>
//       </Modal>
//     </div>
//   );
// };

// export default Messages;
import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import MainLoader from "../../components/loading/MainLoader";
import CustomBreadcrumb from "../../components/customBreadcrumb/CustomBreadcrumb";
import Title from "../../components/title/Title";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import MessageForm from "./message_compose";
import { useNavigate } from "react-router-dom";
import { FiEye } from "react-icons/fi";
import Button from "@mui/material/Button";
import { BASE_URL } from "../../const/URL";
import { useMediaQuery, useTheme } from "@mui/material";

const statusColors: { [key: string]: string } = {
  REQUESTED: "#4caf50",
  ACKNOWLEDGED: "#ff9800",
  COMPLETED: "#2196f3",
};

const Messages = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [loading, setLoading] = useState<boolean>(false);
  const [rows, setRows] = useState<any[]>([]);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const navigate = useNavigate();

  const paginationModel = { page: 0, pageSize: 10 };

  const columns: GridColDef[] = [
    // {
    //   field: "id",
    //   headerName: "Ref No",
    //   width: isSmallScreen ? 80 : 100,
    // },
    {
      field: "crmReference",
      headerName: "Ref No",
      width: isSmallScreen ? 120 : 150,
      renderCell: (params) => (
        <div style={{ whiteSpace: "normal" }}>
          {params.value || "-"}
        </div>
      ),
    },
    {
      field: "subject",
      headerName: "Subject",
      width: isSmallScreen ? 160 : 280,
      renderCell: (params) => (
        <div style={{ whiteSpace: "normal" }}>{params.value}</div>
      ),
    },
    //remove service address from the table
    // {
    //   field: "serviceAddress",
    //   headerName: "Service Address",
    //   width: isSmallScreen ? 140 : 200,
    //   renderCell: (params) => (
    //     <div style={{ whiteSpace: "normal" }}>
    //       {params.value || "-"}
    //     </div>
    //   ),
    // },
    {
      field: "serviceLocationIdentifier",
      headerName: "Service Location Identifier",
      width: isSmallScreen ? 140 : 200,
      renderCell: (params) => (
        <div style={{ whiteSpace: "normal" }}>
          {params.value || "-"}
        </div>
      ),
    },
    {
      field: "createdAt",
      headerName: "Date",
      width: isSmallScreen ? 120 : 200,
    },
    {
      field: "origin",
      headerName: "Originator",
      width: isSmallScreen ? 120 : 200,
    },
    
    {
      field: "status",
      headerName: "Status",
      width: isSmallScreen ? 110 : 130,
      renderCell: (params) => (
        <span
          style={{
            padding: "3px 8px",
            borderRadius: "15px",
            color: "#fff",
            backgroundColor: statusColors[params.value] || "#607d8b",
            fontWeight: "bold",
            textTransform: "capitalize",
            fontSize: isSmallScreen ? "0.75rem" : "0.875rem",
          }}
        >
          {params.value}
        </span>
      ),
    },
    {
      field: "actions",
      headerName: "",
      width: 60,
      renderCell: (params) => (
        <Button
          onClick={() =>
            navigate(`/messages/inbox/${params.row.id}`, {
              state: { subject: params.row.subject, status: params.row.status },
            })
          }
          startIcon={
            <FiEye
              style={{
                color: "#143D60",
                fontSize: isSmallScreen ? "1rem" : "1.25rem",
              }}
            />
          }
          style={{
            minWidth: "auto",
            padding: "6px",
            color: "white",
            border: "none",
            borderRadius: "20px",
            cursor: "pointer",
          }}
        />
      ),
    },
  ];

  const fetchMessages = useCallback(async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("enterprise_portal_access_Token");
      const response = await axios.get(
        `${BASE_URL}/api/v1/conversations/company`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.isSuccess) {
        const formattedRows = response.data.dataBundle.map((item: any) => ({
          id: item.id,
          subject: item.circuit
            ? `${item.subject} - ${item.circuit}`
            : item.subject,
          serviceAddress: item.serviceAddress,
          serviceLocationIdentifier: item.serviceLocationIdentifier,
          createdAt: new Date(item.createdAt).toLocaleString(),
          origin: item.origin,
          crmReference: item.crmReference,
          status: item.status,
          unReadMsgCount: item.unReadMsgCount || 0,
        }));
        setRows(formattedRows);
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchMessages();
  }, [fetchMessages]);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => {
    setOpenModal(false);
    fetchMessages();
  };

  return (
    <div
      className="page-container"
      style={{ padding: isSmallScreen ? "8px" : "16px" }}
    >
      <MainLoader show={loading} />

      <CustomBreadcrumb
        items={[
          { path: "/", title: "Home" },
          { path: "/messages/inbox", title: "Messages" },
        ]}
      />

      <Title>Messages</Title>

      <Paper
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          height: "100%",
          minHeight: 300,
          overflow: "auto",
          p: 1,
          mx: "auto",
          width: "100%",
          "& .MuiTablePagination-root": {
            display: "flex",
            alignItems: "baseline",
            justifyContent: "flex-end",
            minHeight: "56px",
            gap: "8px",
          },
          "& .MuiTablePagination-spacer": {
            order: 2,
          },
          "& .MuiTablePagination-selectLabel": {
            order: 0,
            display: "flex",
            alignItems: "baseline",
            padding: "15px",
            height: "36px",
          },
          "& .MuiTablePagination-select": {
            order: 1,
            display: "flex",
            alignItems: "center",
            height: "36px",
          },
          "& .MuiTablePagination-displayedRows": {
            order: 3,
            display: "flex",
            padding: "15px",
            alignItems: "baseline",
            height: "36px",
          },
          "& .MuiTablePagination-actions": {
            order: 4,
            display: "flex",
            alignItems: "center",
            marginLeft: "auto",
          },
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          initialState={{ pagination: { paginationModel } }}
          pageSizeOptions={[5, 10, 15]}
          getRowClassName={(params) =>
            params.row.unReadMsgCount > 0 ? "unread-row" : ""
          }
          sx={{
            border: 0,
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#E4EFE7",
              color: "GrayText",
              fontSize: isSmallScreen ? "0.875rem" : "1rem",
              fontWeight: "bold",
            },
            "& .MuiDataGrid-cell": {
              fontSize: isSmallScreen ? "0.75rem" : "0.875rem",
              fontWeight: "500",
            },
            "& .MuiDataGrid-row": {
              "&.unread-row": {
                backgroundColor: "#fff3e0",
                "& .MuiDataGrid-cell": {
                  fontWeight: "bold !important",
                },
              },
            },
          }}
          autoHeight
          density={isSmallScreen ? "compact" : "standard"}
        />
      </Paper>

      <Fab
        color="primary"
        aria-label="add"
        size={isSmallScreen ? "small" : "medium"}
        sx={{
          position: "fixed",
          bottom: 16,
          right: 16,
        }}
        onClick={handleOpenModal}
      >
        <AddIcon fontSize={isSmallScreen ? "small" : "medium"} />
      </Fab>

      <Modal open={openModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: isSmallScreen ? "95%" : "80%",
            maxWidth: "600px",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <MessageForm onClose={handleCloseModal} />
        </Box>
      </Modal>
    </div>
  );
};

export default Messages;
